module.exports = __webpack_public_path__ + "static/media/WOO.6f888b46.svg";